// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3494Z","dragIcon":"SortableItem_dragIcon__1w5tM","disabled":"SortableItem_disabled__2bMVn"};